var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("questionnaire-form-section-group", {
        attrs: {
          response: _vm.response,
          model: _vm.roomTypesModel,
          template: _vm.getTemplate("RTD"),
        },
        on: { change: _vm.$rbEmit },
      }),
      _c("questionnaire-form-section-table", {
        attrs: {
          config: _vm.config,
          globals: _vm.globals,
          model: _vm.model,
          response: _vm.response,
          template: _vm.tableTemplate,
        },
        on: {
          change: _vm.onRateGridValueChange,
          stateChange: _vm.onStateChange,
          mounted: _vm.onSectionMounted,
        },
      }),
      _vm.showRateRuleError
        ? _c(
            "modal",
            {
              on: {
                cancel: function ($event) {
                  _vm.showRateRuleError = false
                },
                submit: function ($event) {
                  _vm.showRateRuleError = false
                },
              },
            },
            [
              _c("span", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("Rate Rule Error"),
              ]),
              _c(
                "div",
                {
                  staticClass: "rateRuleModalBody",
                  attrs: { slot: "body" },
                  slot: "body",
                },
                [
                  _c("p", { staticClass: "rateRuleModalParagraph" }, [
                    _vm._v(" Dear "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.response.answers["PROPNAME"])),
                    ]),
                    _vm._v(", "),
                  ]),
                  _c("p", { staticClass: "rateRuleModalParagraph" }, [
                    _vm._v(
                      " In our ongoing effort to forge strong lodging partnerships as well as keep costs in line with this year’s "
                    ),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.response.answers["CLIENT_NAME"])),
                    ]),
                    _vm._v(
                      " Travel directives, we respectfully requests you keep this year’s rate within "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.rateRuleAmount) + "%")]),
                    _vm._v(" of last years "),
                    _c("strong", [_vm._v("$" + _vm._s(_vm.lastYearRate))]),
                    _vm._v(" Single Standard Rate. "),
                  ]),
                  _c("p", { staticClass: "rateRuleModalParagraph" }, [
                    _vm._v(" We sincerely appreciate your understanding. "),
                  ]),
                ]
              ),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.showRateRuleError = false
                      },
                    },
                  },
                  [_vm._v("OK")]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }